export const SENTRY_COMMON_ERROR_IGNORE_LIST = [
  'EncodingError: Unable to decode audio data',
  'EncodingError: Decoding failed',
  'TypeError: Load failed',
  'TypeError: Failed to fetch',
  'TypeError: NetworkError when attempting to fetch resource.',
  'TypeError: cancelled',
  'TypeError: Cancelled',
  'message: cancelled',
  'Decoding failed',
  'Unable to decode audio data',
  'cancelled',
  'ResizeObserver loop limit exceeded',
  'Receiving end does not exist',
  'privateSpecialRepair is not defined',
  'Cannot access a chrome:// URL',
  'Cannot access a chrome-extension:// URL of different extension',
  'Non-Error promise rejection captured with keys: currentTarget, detail, isTrusted, target'
]

export function sentryEnrichEvent(originalException) {
  const extra = {}
  if (originalException.message) {
    extra.message = originalException.message
  }
  if (originalException.config) {
    extra.config = originalException.config
  }
  if (originalException.request) {
    extra.request = originalException.request
  }
  if (originalException.response) {
    extra.response = originalException.response
  }

  return extra
}
